Object.defineProperty(exports, "__esModule", { value: true });
exports.selfPreReset = void 0;
exports.selfPreReset = {
    ncss: {
        boxSizing: 'border-box',
        fontFamily: 'monospace, monospace',
        fontSize: '1em',
        tabSize: 2,
        wordBreak: 'normal',
        hyphens: 'none',
        overflow: 'hidden',
        overflowX: 'auto',
    },
};
//# sourceMappingURL=self-pre-reset.js.map